import { useState } from 'react';
import { useNavigate } from 'react-router-dom'
import { styled, useTheme } from '@mui/material/styles';
import { Collapse, Divider, Drawer, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, ListSubheader, useMediaQuery } from '@mui/material';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';
import PaidIcon from '@mui/icons-material/Paid';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SavingsIcon from '@mui/icons-material/Savings';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import MonitorIcon from '@mui/icons-material/Monitor';
import DashboardIcon from '@mui/icons-material/Dashboard';
import FolderSpecialOutlinedIcon from '@mui/icons-material/FolderSpecialOutlined';
import ArticleIcon from '@mui/icons-material/Article';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';


import useAuth from '../hooks/useAuth';
import SearchStock from './SearchStock';

const drawerWidth = 240;

const DrawerHeader = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	padding: theme.spacing(0, 1),
	// necessary for content to be below app bar
	...theme.mixins.toolbar,
	justifyContent: 'flex-end',
}));

const SideMenu = ({open, setOpen, handleDrawerOpen, handleDrawerClose}) => { 
	const theme = useTheme();

	const [transactionsOpen, setTransactionsOpen] 	= useState(false);
	const [portfolioOpen, setPortfolioOpen] 		= useState(false);
	const [stockScreenerOpen, setStockScreenerOpen]	= useState(false);
	const [bondsOpen, setBondsOpen]					= useState(false);

	const navigate = useNavigate()
	const auth	= useAuth();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

	const handleSubMenuClick = (menu) => {
		switch (menu) {
			case 'transactions' : setTransactionsOpen(!transactionsOpen); break;
			case 'portfolio'	: setPortfolioOpen(!portfolioOpen); break;
			case 'stockScreener': setStockScreenerOpen(!stockScreenerOpen); break;
			case 'bonds'		: setBondsOpen(!bondsOpen); break;
		}
	}

	const handleNavigate = (pDst) => {
		setOpen(false)
		navigate(pDst)
	}
	
	return (
		<Drawer
			sx={{
				width: drawerWidth,
				flexShrink: 0,
				'& .MuiDrawer-paper': {
				width: drawerWidth,
				boxSizing: 'border-box',
				},
			}}
			variant="persistent"
			anchor="left"
			open={open}
		>
			<DrawerHeader>
				<IconButton onClick={handleDrawerClose}>
					{theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
				</IconButton>
			</DrawerHeader>

			<Divider />
			<List>
				{ isSmallScreen ? (
					<ListItem key="Search" disablePadding >
						<SearchStock 
							usePlaceHolder
							label="Digite o Ticker ou Nome da Empresa"
							sx={{
								backgroundColor: 'white',
								"& .MuiOutlinedInput-notchedOutline": {
									borderColor: "#3f51b5"
								},
								"&:hover:not(.Mui-focused)": {
									"& .MuiOutlinedInput-notchedOutline": {
									borderColor: "#3f51b5",
									borderWidth: '1px'
									},
								},							
								borderRadius: '4px',
								width: '90%'
							}}
							onClick={(result) => {
								navigate("/company/"+ result.ticker)
								navigate(0)
							}}
						/>
					</ListItem>
				) : null}

				<ListItem key="Home" disablePadding>
					<ListItemButton onClick={() => handleNavigate("/")}>
						<ListItemIcon><HomeIcon /></ListItemIcon>
						<ListItemText primary="Home" />
					</ListItemButton>
				</ListItem>				
				<ListItem key="Dashboard" disablePadding>
					<ListItemButton onClick={() => handleNavigate("/dashboard")}>
						<ListItemIcon><DashboardIcon /></ListItemIcon>
						<ListItemText primary="Dashboard" />
					</ListItemButton>
				</ListItem>
				<ListItem key="Conteúdos" disablePadding>
					<ListItemButton onClick={() => handleNavigate("/contents")}>
						<ListItemIcon><ArticleIcon /></ListItemIcon>
						<ListItemText primary="Conteúdos" />
					</ListItemButton>
				</ListItem>
				<ListItem key="Listas" disablePadding>
					<ListItemButton onClick={() => handleNavigate("/rankings")}>
						<ListItemIcon><EmojiEventsIcon /></ListItemIcon>
						<ListItemText primary="Listas" />
					</ListItemButton>
				</ListItem>
				<ListItem key="Calendário" disablePadding>
					<ListItemButton onClick={() => handleNavigate("/calendar")}>
						<ListItemIcon><CalendarMonthIcon /></ListItemIcon>
						<ListItemText primary="Calendário" />
					</ListItemButton>
				</ListItem>
				<ListItem key="StockScreener" disablePadding>
					<ListItemButton onClick={() => handleNavigate("/stockScreener/BR")} >
						<ListItemIcon><SearchIcon /></ListItemIcon>
						<ListItemText primary="Stock Screener" />
					</ListItemButton>
				</ListItem>

				<ListItem disablePadding>
					<ListItemButton onClick={() => handleNavigate("/portfolio")} sx={{display: "flex",alignItems: "center",width: "100%",pr: 1}}>
						<ListItemIcon><FolderSpecialOutlinedIcon /></ListItemIcon>
						<ListItemText primary="Meu Portfólio" sx={{ flex: 1 }}/>
					</ListItemButton>

					<IconButton onClick={(e) => {e.stopPropagation(); handleSubMenuClick("portfolio");}} sx={{mr: 1}}>
						{portfolioOpen ? <ExpandLess /> : <ExpandMore />}
					</IconButton>
				</ListItem>
				<Collapse in={portfolioOpen} timeout="auto" unmountOnExit>
					<List component="div" disablePadding>
						<ListItemButton onClick={() => handleNavigate("/portfolio/ACAO")} sx={{ pl: 9, fontSize:'12px' }}>
							<ListItemText primary="Ações" primaryTypographyProps={{fontSize: '0.8rem'}} />
						</ListItemButton>
						<ListItemButton onClick={() => handleNavigate("/portfolio/STOCK")} sx={{ pl: 9, fontSize:'12px' }}>
							<ListItemText primary="Stocks" primaryTypographyProps={{fontSize: '0.8rem'}} />
						</ListItemButton>
					</List>
				</Collapse>
		
				<ListItem key="Minhas Transações" disablePadding onClick={() => handleSubMenuClick('transactions')}>
					<ListItemButton>
						<ListItemIcon><ReceiptLongIcon /></ListItemIcon>
						<ListItemText primary="Minhas Transações" />
						{transactionsOpen ? <ExpandLess /> : <ExpandMore />}
					</ListItemButton>
				</ListItem>				
				<Collapse in={transactionsOpen} timeout="auto" unmountOnExit>
					<List component="div" disablePadding>
						<ListItemButton onClick={() => handleNavigate("/transactions/acao")} sx={{ pl: 9, fontSize:'12px' }}>
							<ListItemText primary="Ações" primaryTypographyProps={{fontSize: '0.8rem'}} />
						</ListItemButton>
						<ListItemButton onClick={() => handleNavigate("/transactions/stock")} sx={{ pl: 9, fontSize:'12px' }}>
							<ListItemText primary="Stocks" primaryTypographyProps={{fontSize: '0.8rem'}} />
						</ListItemButton>
						{ auth.auth.userId < 100 ? (
							<>
								<ListItemButton onClick={() => handleNavigate("/transactions/fii")} sx={{ pl: 9 }}>
									<ListItemText primary="FIIs" primaryTypographyProps={{fontSize: '0.8rem'}} />
								</ListItemButton>
								<ListItemButton onClick={() => handleNavigate("/transactionsFixedIncome/BR")} sx={{ pl: 9 }}>
									<ListItemText primary="Tesouro Direto" primaryTypographyProps={{fontSize: '0.8rem'}} />
								</ListItemButton>
								<ListItemButton onClick={() => handleNavigate("/transactionsFixedIncome/US")} sx={{ pl: 9 }}>
									<ListItemText primary="Bonds" primaryTypographyProps={{fontSize: '0.8rem'}} />
								</ListItemButton>	
							</>
						) : null}
					</List>
				</Collapse>

				<ListItem key="Meus Proventos" disablePadding>
					<ListItemButton onClick={() => handleNavigate("/dividends")}>
						<ListItemIcon><PaidIcon /></ListItemIcon>
						<ListItemText primary="Meus Proventos" />
					</ListItemButton>
				</ListItem>		

				{ auth.auth.userId < 100 ? (
					<>
						<ListItem key="Bonds" disablePadding onClick={() => handleSubMenuClick('bonds')}>
							<ListItemButton>
								<ListItemIcon>
								<AccountBalanceIcon />
								</ListItemIcon>
								<ListItemText primary="Títulos" />
								{bondsOpen ? <ExpandLess /> : <ExpandMore />}
							</ListItemButton>
						</ListItem>	
						<Collapse in={bondsOpen} timeout="auto" unmountOnExit>
							<List component="div" disablePadding>
								<ListItemButton onClick={() => handleNavigate("/bonds/BR")} sx={{ pl: 9, fontSize:'12px' }}>
									<ListItemText primary="Tesouro Direto" primaryTypographyProps={{fontSize: '0.8rem'}} />
								</ListItemButton>
								<ListItemButton onClick={() => handleNavigate("/bonds/US")} sx={{ pl: 9, fontSize:'12px' }}>
									<ListItemText primary="Bonds" primaryTypographyProps={{fontSize: '0.8rem'}} />
								</ListItemButton>
							</List>
						</Collapse>				

						<ListItem key="BankSavings" disablePadding>
							<ListItemButton onClick={() => handleNavigate("/bankSavings")}>
								<ListItemIcon>
								<SavingsIcon />
								</ListItemIcon>
								<ListItemText primary="Bank & Savings" />
							</ListItemButton>
						</ListItem>		
					</>
				) : null}
							
			</List>

			{ auth.auth.userId < 100 ? (
				<>
					<Divider />

					<List>
						<ListSubheader component="div" id="nested-list-subheader">
								Configurações
						</ListSubheader>
						<ListItem key="OperationPanel" disablePadding>
							<ListItemButton onClick={() => handleNavigate("/operationPanel")}>
								<ListItemIcon>
								<MonitorIcon />
								</ListItemIcon>
								<ListItemText primary="Operation Panel" />
							</ListItemButton>
						</ListItem>				
					</List>
				</>
			) : null}
			
			
	  </Drawer>
	)
}

export default SideMenu

